<template>
  <HandlerIos
    v-if="isIos && !forceWeb"
    :loading="loadingBrowser"
    @loginBrowser="loginInBrowser"
  />
  <HandlerAndroid
    v-else-if="isAndroid && !forceWeb"
    :loading="loadingBrowser"
    @loginBrowser="loginInBrowser"
  />
  <div v-else class="d-flex align-items-center justify-content-center vh-100">
    <div class="text-center">
      <div class="spinner-border text-primary mb-3" role="status"></div>
      <p class="fs-14 color-neutral-600">Memverifikasi login WhatsApp...</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { verifikasiWaLogin } from '@/core/auth'
import { showNotif } from '@/core/utility'
import HandlerIos from '@/components/auth/waLogin/HandlerIos.vue'
import HandlerAndroid from '@/components/auth/waLogin/HandlerAndroid.vue'

export default {
  components: {
    HandlerIos,
    HandlerAndroid
  },
  setup () {
    const route = useRoute()
    const router = useRouter()

    const isIos = navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad')
    const isAndroid = navigator.userAgent.includes('Android')
    const forceWeb = route.query.web === '1'
    const loadingBrowser = ref(false)

    const doVerifikasi = async () => {
      const token_wa_login = route.params.token
      try {
        const { status, message } = await verifikasiWaLogin({ token_wa_login })

        if (status) {
          const user = JSON.parse(localStorage.getItem('user'))
          if (user.status_text === 'Belum Registrasi') {
            return router.push({ name: 'SettingPersonalData' })
          } else {
            return router.push({ name: 'Home' })
          }
        } else {
          showNotif({ status: 'error', message })
          router.push({ name: 'Login' })
        }
      } catch (error) {
        const message = error?.response?.data?.message || 'Terjadi kesalahan, silahkan coba lagi.'
        showNotif({ status: 'error', message })
        router.push({ name: 'Login' })
      }
    }

    const loginInBrowser = async () => {
      loadingBrowser.value = true
      await doVerifikasi()
      loadingBrowser.value = false
    }

    onMounted(() => {
      // Desktop atau fallback dari intent (app tidak terinstall) → langsung proses verifikasi
      if ((!isIos && !isAndroid) || forceWeb) {
        doVerifikasi()
      }
    })

    return {
      isIos,
      isAndroid,
      forceWeb,
      loadingBrowser,
      loginInBrowser
    }
  }
}
</script>
